module.exports = __webpack_public_path__ + "static/img/bannerA.11fb65fc.jpg";